import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BrandTitle from "../../components/BrandTitle/BrandTitle";
import RandomQuote from "../../components/RandomQuote/RandomQuote";
import Spinner from "../../components/Spinner/Spinner";
import useAuthStore from "../../store/authStore";
import { useTranslation } from "react-i18next";

export default function ChangePasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = useAuthStore((state) => state.token);
  const logout = useAuthStore((state) => state.logout);
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (form.newPassword !== form.confirmPassword) {
      return setError(t("auth.changePassword.mismatch"));
    }

    setIsLoading(true);

    try {
      const res = await fetch(
        `${import.meta.env.VITE_API_URL}/api/auth/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            oldPassword: form.oldPassword,
            newPassword: form.newPassword,
          }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t("auth.changePassword.failed"));

      // Stores the translation key so it follows language changes
      setMessage("auth.changePassword.success");
      setForm({ oldPassword: "", newPassword: "", confirmPassword: "" });

      // Logout user after successful password change
      logout();

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="authentication-view">
      <div className="left-wrapper">
        <div className="title">
          <BrandTitle fontSize={40} className="brand-title-login" />
        </div>
        <div className="quote">
          <RandomQuote />
        </div>
      </div>
      <div className="right-wrapper">
        <div className="title">{t("auth.changePassword.title")}</div>
        <form onSubmit={handleSubmit}>
          <input
            className="flow-form"
            name="oldPassword"
            type="password"
            placeholder={t("auth.changePassword.currentPassword")}
            value={form.oldPassword}
            onChange={handleChange}
            required
          />
          <br />
          <input
            className="flow-form"
            name="newPassword"
            type="password"
            placeholder={t("auth.newPassword")}
            value={form.newPassword}
            onChange={handleChange}
            required
          />
          <br />
          <input
            className="flow-form"
            name="confirmPassword"
            type="password"
            placeholder={t("auth.changePassword.confirmNewPassword")}
            value={form.confirmPassword}
            onChange={handleChange}
            required
          />
          <br />
          <button type="submit" className="flow-button" disabled={isLoading}>
            {t("auth.changePassword.submit")}
          </button>
        </form>
        {isLoading && <Spinner text={t("auth.changePassword.updating")} />}
        {error && (
          <span
            style={{
              color: "var(--error-color)",
              marginTop: "10px",
              marginBottom: "-10px",
            }}
          >
            {error}
          </span>
        )}
        {message && (
          <span
            style={{
              color: "var(--success-color)",
              marginTop: "10px",
              marginBottom: "-10px",
            }}
          >
            {t(message)}
          </span>
        )}
        <p>
          <a className="link" href="/login">
            &larr; {t("auth.backToLogin")}
          </a>
        </p>
      </div>
    </div>
  );
}
